import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@whizz/react-i18n';
import Button from '../button/Button';
import Loader from '../loader/Loader';
import { ValueHeadline } from '../../pages/Home/modules';

export interface SelectionAction {
  key: string;
  count: number;
  description: string;
  buttonLabel: ReactNode;
  onClick: () => void;
  isLoading?: boolean;
  icon?: string;
}

interface SelectionActionControlProps {
  actions: SelectionAction[];
}

const SelectionActionBlockStyled = styled('div')`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 125px;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 20;
`;

const SelectionActionControl = ({ actions }: SelectionActionControlProps): JSX.Element | null => {
  const visibleActions = actions.filter((action) => action.count > 0);

  if (0 === visibleActions.length) {
    return null;
  }

  return (
    <SelectionActionBlockStyled>
      <div className={'flex flex-wrap justify-center items-center gap-4'}>
        {visibleActions.map((action) => (
          <div key={action.key} className={'flex justify-center items-center gap-6 bg-white rounded-default py-6 px-14'}>
            <ValueHeadline
              value={action.count}
              description={action.description}
              showMoreInfo={false}
              colorValue
              className={'flex items-center'}
            />
            <Button
              isOutline
              color={'positive'}
              icon={action.icon ?? 'ArrowForward'}
              size={'lg'}
              onClick={action.onClick}
              disabled={action.isLoading}
            >
              {!action.isLoading ? action.buttonLabel : (<Loader disableLabel smallSize />)}
            </Button>
          </div>
        ))}
      </div>
    </SelectionActionBlockStyled>
  );
};

const Continue = ({ onClick, isLoading = false, count }: { onClick: () => void, isLoading?: boolean, count: number }): JSX.Element | null => {
  const { translate } = useI18n();

  return (
    <SelectionActionControl
      actions={[ {
        key: 'continue',
        count,
        description: translate('pages.ROSTER_MANAGEMENT.STUDENTS.SELECTED_STUDENTS', { count }),
        buttonLabel: translate('components.BUTTONS.CONTINUE'),
        onClick,
        isLoading,
      } ]}
    />
  );
};

export { Continue, SelectionActionControl };
